import React, { useState, useEffect } from "react";
import { database } from "../firebaseConfig";
import { ref, get } from "firebase/database";
import { useNavigate } from "react-router-dom";
import ProductCard from "./ProductCard";
import "./RelatedProducts.css";

const RelatedProducts = ({ relatedProductsStr, cardsPerRow = 3, cardsPerRowPhoneView = 2 }) => {
    const [related, setRelated] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (!relatedProductsStr) {
            setRelated([]);
            setLoading(false);
            return;
        }
        const skus = relatedProductsStr.split(",").map((sku) => sku.trim());
        const fetchRelatedProducts = async () => {
            try {
                const snapshot = await get(ref(database, "categories"));
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    const catArray = Array.isArray(data) ? data : Object.values(data);
                    let allProducts = [];
                    catArray.forEach((cat) => {
                        if (cat.products) {
                            const prodArray = Array.isArray(cat.products)
                                ? cat.products
                                : Object.values(cat.products);
                            allProducts = allProducts.concat(prodArray);
                        }
                    });
                    const filtered = allProducts.filter((prod) => skus.includes(prod.sku));
                    setRelated(filtered);
                }
            } catch (error) {
                console.error("Error fetching related products:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRelatedProducts();
    }, [relatedProductsStr]);

    const handleRelatedProductClick = (product) => {
        navigate("/product-details", { state: { product } });
    };

    if (loading) {
        return <p className="related-loading">Loading related products...</p>;
    }

    if (related.length === 0) {
        return <p className="related-loading">No related products found.</p>;
    }

    return (
        <div className="related-products">
            <h2 className="related-title">Related Products</h2>
            <div
                className="related-products-grid"
                style={{ gridTemplateColumns: `repeat(${cardsPerRow}, 1fr)` }}
            >
                {related.map((prod, index) => (
                    <div
                        key={index}
                        onClick={() => handleRelatedProductClick(prod)}
                        style={{ cursor: "pointer" }}
                    >
                        <ProductCard
                            title={prod.name || "Product Name"}
                            description={prod.description || ""}
                            price={prod.sellingPrice || ""}
                            mrp={prod.mrp || ""}
                            discount={prod.discount || ""}
                            rating={prod.rating || ""}
                            mediaUrl={prod.image || "https://via.placeholder.com/300x200"}
                            mediaType="image"
                            edit={false}
                            cardsPerRow={cardsPerRow}
                            cardsPerRowPhoneView={cardsPerRowPhoneView}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RelatedProducts;
